import UserInfo from "../../classes/userInfo";
import useQueryUserInfo from "../queries/useQueryUserInfo";

export default function useUserInfo() {
  const userInfoQuery = useQueryUserInfo();

  let userInfo = null;

  if (userInfoQuery.isSuccess && userInfoQuery.data) {
    userInfo = new UserInfo(userInfoQuery.data);
  }

  // todo: rename userInfo to userInfoData
  return { userInfo, userInfoQuery };
}
